import { Component, OnInit, HostBinding } from '@angular/core';
import { AlgGtmService } from '../../services/alg-gtm.service';

@Component({
  selector: 'alg-sidebar',
  templateUrl: './alg-sidebar.component.html',
  styleUrls: ['./alg-sidebar.component.scss']
})
export class AlgSidebarComponent implements OnInit {
  @HostBinding('class.open') isOpen: boolean = false;

  constructor(private gtm: AlgGtmService) { }

  ngOnInit() {
  }

  public toggle(){
    this.isOpen = ! this.isOpen;
    this.gtm.submitOnbEvent('Click su bottone info');
    if (this.isOpen) {
      document.body.style.position = 'fixed';
    }else{
      document.body.style.position = 'relative';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/alg-sidebar/alg-sidebar.component.ts